import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';
import type { SayButton } from '@/modules/hiring-manager/chat/chatResults';
import { Button } from '@/modules/ui/components/button/Button';

interface SendButtonProps {
  action: SayButton;
  onSend: (text: string) => void;
  disabled: boolean;
  sending?: string;
  variant?: 'outline' | 'ghost';
}

/** A button that sends its message as the HM's next one, and shows it's working while that message is sent. */
export function SendButton({
  action,
  onSend,
  disabled,
  sending,
  variant = 'outline',
}: SendButtonProps) {
  const pending = disabled && sending === action.message;
  return (
    <Button
      className={cn(pending && 'disabled:opacity-100')}
      disabled={disabled}
      onClick={() => onSend(action.message)}
      size="sm"
      variant={variant}
    >
      {pending && <Loader2 className="size-3.5 animate-spin" />}
      {action.label}
    </Button>
  );
}
